import { render, staticRenderFns } from "./study-list.vue?vue&type=template&id=53fc480c&scoped=true&"
import script from "./study-list.vue?vue&type=script&lang=ts&"
export * from "./study-list.vue?vue&type=script&lang=ts&"
import style0 from "./study-list.vue?vue&type=style&index=0&id=53fc480c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fc480c",
  null
  
)

export default component.exports